import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createClient = createAsyncThunk(
  "client/createClient",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/client/createClient",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);
export const getClientDataById = createAsyncThunk(
  "client/getClientById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/client/getClientById",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

export const updateClient = createAsyncThunk(
  "client/updateClient",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/client/updateClient",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

export const deleteClient= createAsyncThunk(
  "client/deleteClient",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/client/deleteClient",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

const initialState = {
  loading: false,
  client: [],
  error: null,
  isLoading: false,
  createclientUserSuccessMessage: null,
  createclientUserErrorMessage: null,
  updateclientUserSuccessMessage: null,
  updateclientUserErrorMessage: null,
  deleteclientUserSuccessMessage: null,
  deleteclientUserErrorMessage: null,
  searchMessage: null,
};

const clientUserSlice = createSlice({
  name: "clientUser",
  initialState,
  reducers: {
    resetCreateMessages: (state) => {
      state.createclientUserSuccessMessage = null;
      state.createclientUserErrorMessage = null;
    },
    resetUpdateMessages: (state) => {
      state.updateclientUserSuccessMessage = null;
      state.updateclientUserErrorMessage = null;
    },
    resetDeleteMessages: (state) => {
      state.deleteclientUserSuccessMessage = null;
      state.deleteclientUserErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder 
   
      .addCase(createClient.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createClient.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.createclientUserErrorMessage = action.payload.result.message;
        } else {
          state.createclientUserSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(createClient.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateClient.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateClient.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === true) {
          state.updateclientUserSuccessMessage = action.payload.result.message;
        } else {
          state.updateclientUserErrorMessage = action.payload.result.message;
        }
      })
      .addCase(updateClient.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(deleteClient.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteClient.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === true) {
          state.deleteclientUserSuccessMessage = action.payload.result.message;
        } else {
          state.deleteclientUserErrorMessage = action.payload.result.message;
        }
      })
      .addCase(deleteClient.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getClientDataById.pending, (state) => {
        state.isLoading = true;
    })
    .addCase(getClientDataById.fulfilled, (state, action) => {
      state.isLoading = false;
      if (action.payload.success) {
        state.client = action.payload.result.list;
      } else {
        state.errorMessage = action.payload.result.message;
      }
    })
    .addCase(getClientDataById.rejected, (state, action) => {
      state.isLoading = false;      
      state.errorMessage = action.payload || "Failed to fetch client";
    });
  },
});
export const { resetCreateMessages, resetUpdateMessages, resetDeleteMessages } =
  clientUserSlice.actions;
export default clientUserSlice.reducer;
